import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { CambiarContrasenaService } from 'src/app/services/cambiar-Contrasena.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { BancoldexService } from 'src/app/comun/services/bancoldex.service';
import { Router } from '@angular/router';
import { PASSWORD_COMPLEXITY_PATTERN } from 'src/app/shared/utils/validation.constants';

declare var $:any;

const mensajeDeshabilitarUser = 'PAR-107';

@Component({
    selector: 'app-eliminar-cuenta',
    templateUrl: './eliminar-cuenta.component.html',
    styleUrls: ['./eliminar-cuenta.component.scss'],
    standalone: false
})
export class EliminarCuentaComponent implements OnInit {
  validarContrasena = PASSWORD_COMPLEXITY_PATTERN;  isVisible: boolean = false;
  isVisibleNueva: boolean = false;
  isLoading: boolean = false;
  mensajeDeshabilitarUser: string;

  constructor(private formBuilder: UntypedFormBuilder,
    private user: UserService,
    private _sweetAlert:SweetAlertService,
    private _bancoldexService: BancoldexService,   
    private router: Router
    ) {
      this.getMensajeDeshabilitarUser();
    }

  public eliminarCuentaForm = this.formBuilder.group({
    contraActual: ['', [Validators.required, Validators.minLength(8), Validators.pattern(this.validarContrasena)]],
    observaciones: ['', [Validators.required, Validators.minLength(50)]],
  },
  );

  ngOnInit() {
  }

  showPassword() {
    this.isVisible = !this.isVisible;
  }

  validateField(key: string) {
    return (
      (this.eliminarCuentaForm.get(key).dirty ||
        this.eliminarCuentaForm.get(key)?.touched) &&
      this.eliminarCuentaForm.get(key)?.invalid
    );
  }

  validateForm() {
    if (this.eliminarCuentaForm.valid) {
      this.desahabilitarCuenta();
    } else {
      this.eliminarCuentaForm.markAllAsTouched();
    }
  }

  desahabilitarCuenta() {
    
    this.isLoading = true;
    this._sweetAlert.infoModal('¡Atención!',true,this.mensajeDeshabilitarUser).then((result)=>{
      if (result.isConfirmed) {
        this.deshabilitar();
      }
      this.isLoading = false;
    });
  }

  deshabilitar() {
    const datosAut:any = {
      idUsuario: Number(this.user.getUser().idUsuario),
      contrasena: this.eliminarCuentaForm.get('contraActual').value,
      observacion: this.eliminarCuentaForm.get('observaciones').value
    }

    this._bancoldexService.getDeshabilitarUsuario(datosAut).subscribe((data: any) => {
      if (data.exitoso == true) {
        this._sweetAlert.infoModal("Información",true,"El usuario ha sido deshabilitado ");
        this.closeSession();
      } else {
        this._sweetAlert.infoModal(data.error,false);
      }
      });
  }

  getMensajeDeshabilitarUser() {
    var json = {
      idParametro: mensajeDeshabilitarUser,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.mensajeDeshabilitarUser = respuesta[0].valorParametro;
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
  }

  async closeSession() {
    await this.user.deleteUser();
    this.router.navigateByUrl('/home');
  }
}
